import type { SiteContent } from "./types";

/**
 * Production content source of truth.
 * Temporary Coverr clips are used only until Halim's final showreel is ready.
 */
export const siteContent: SiteContent = {
  pageTitle: "Contact — Halim Alrasihi",
  brand: {
    name: "Halim Alrasihi",
    href: "/contact",
    mark: { kind: "initials", text: "H" },
  },
  header: {
    mediaLabel: "Selected work",
    mediaYear: "2026",
    availabilityText: "Available for selected projects",
  },
  contact: {
    eyebrow: "Inquiries & collaborations",
    headline: "Let’s make something worth remembering.",
    introduction:
      "Tell me about the project, the idea, or the feeling you want to create. I’ll read every message and get back to you personally.",
    submitLabel: "Send inquiry",
    sendingLabel: "Sending…",
  },
  success: {
    eyebrow: "Sent successfully",
    title: "Message received.",
    message: "Thank you for reaching out. I’ll be in touch as soon as I can.",
    resetLabel: "Send another inquiry",
  },
  privacy: {
    summary: "I’ll use your details only to respond to your inquiry.",
    linkLabel: "Privacy notice",
    url: "#privacy",
    eyebrow: "Privacy",
    title: "Your message stays purposeful.",
    paragraphs: [
      "Your submitted details are used only to review and respond to your inquiry. Submissions are processed through Cloudflare and stored in a private Google Form owned by Halim Alrasihi.",
      "The complete legal privacy notice and retention period will be added before public launch.",
    ],
  },
  fallbackForm: {
    url: "",
    label: "Use the Google Form instead.",
  },
  testimonialsLabel: "Kind words",
  testimonials: [
    {
      id: "placeholder-one",
      quote: "Replace this card with an approved client testimonial.",
      clientName: "Client name",
      role: "Role",
      company: "Company",
    },
    {
      id: "placeholder-two",
      quote: "A concise, specific result makes a testimonial feel credible and human.",
      clientName: "Client name",
      role: "Creative partner",
    },
    {
      id: "placeholder-three",
      quote: "Add, remove, or reorder these cards from one content file.",
      clientName: "Client name",
      role: "Project lead",
    },
  ],
  showreel: {
    poster: "/media/showreel-poster.svg",
    posterAlt: "Cinematic portfolio footage",
    randomizeStart: true,
    crossfadeMs: 1100,
    clips: [
      {
        id: "above-a-misty-forest",
        desktop: {
          mp4: "https://cdn.coverr.co/videos/coverr-above-a-misty-forest-518/720p.mp4",
        },
        sourcePage: "https://coverr.co/videos/above-a-misty-forest-1xvix1tpnr",
        alt: "A cinematic aerial view moving above a misty forest",
        tone: "dark",
      },
      {
        id: "a-barren-desert",
        desktop: {
          mp4: "https://cdn.coverr.co/videos/coverr-a-barren-desert-4652/720p.mp4",
        },
        sourcePage: "https://coverr.co/videos/a-barren-desert-sun7caogp0",
        alt: "A cinematic view moving across a sunlit desert landscape",
        tone: "bright",
      },
      {
        id: "dark-forest",
        desktop: {
          mp4: "https://cdn.coverr.co/videos/coverr-dark-forest-1109/720p.mp4",
        },
        sourcePage: "https://coverr.co/videos/foggy-forest-06yshrbpk8",
        alt: "A shadowy cinematic forest with gentle natural movement",
        tone: "dark",
      },
      {
        id: "waves-in-the-ocean",
        desktop: {
          mp4: "https://cdn.coverr.co/videos/coverr-waves-in-the-ocean-9927/720p.mp4",
        },
        sourcePage: "https://coverr.co/videos/waves-in-the-ocean-7ptcsz5cuw",
        alt: "A cinematic aerial view of ocean waves at sunset",
        tone: "bright",
      },
    ],
  },
};
